export enum ClubReminderTypeEnum {
    unreportedFormsForTheWholeDay = "UNREPORTED_FORMS_FOR_THE_WHOLE_DAY"
}
